// extracted by mini-css-extract-plugin
module.exports = {"PostMenuTrigger":"ps_a bhv_i bhv_j bhv_q bhv_un bhv_wf bhv_en"};